import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import CloseIcon from '@/components/_other/icons/CloseIcon';

const Modal = ({
  open = false,
  title = null,
  footer = null,
  afterOpen = null,
  onClose = null,
  children,
  className = '',
  noWrap = false,
  closeByOutsideClick = false,
  size = 'lg',
  fullScreen = false,
}) => {
  const [isBrowser, setIsBrowser] = useState(false);

  const modalSize =
    size === 'sm'
      ? 'modal-sm'
      : size === 'md'
        ? ''
        : size === 'lg'
          ? 'modal-lg'
          : size === 'xl'
            ? 'modal-xl'
            : '';

  // create modal wrapper element
  useEffect(() => {
    const modalElement = document.getElementById('g-modal');
    if (!modalElement) {
      var element = document.createElement('div');
      element.id = 'g-modal';
      document.body.appendChild(element);
    }
    setIsBrowser(true);
  }, [setIsBrowser]);

  if (!open || !isBrowser) {
    return null;
  }

  const inlineStyle = { display: open ? 'block' : 'hidden' };

  return createPortal(
    <>
      <div
        className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 bottom-0 z-50 justify-center items-center w-full md:inset-0 h-full max-h-full bg-black bg-opacity-40"
        onClick={closeByOutsideClick ? onClose : () => {}}
        id="modal"
        style={inlineStyle}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modal"
        aria-modal="true"
        role="dialog"
      >
        <div
          onClick={event => closeByOutsideClick && event.stopPropagation()}
          className={`${fullScreen ? 'w-full inset-0' : 'px-4 pt-8 w-full max-w-2xl'} max-h-full absolute top-0 left-[50%] -translate-x-[50%] ${
            className || ''
          }`}
        >
          <div className={`relative bg-white ${fullScreen ? 'h-full' : 'border-black shadow-sm border'}`}>
            <div className="text-center pt-8 mb-5">
              {title ? (
                <h3 className="mb-0" id="modalLabel">
                  {title}
                </h3>
              ) : null}

              <button
                type="button"
                className="absolute top-2 right-2"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onClose}
              >
                <CloseIcon />
              </button>
            </div>
            <div className="px-4 pb-4">{children}</div>
            {footer ? <div className="modal-footer">{footer}</div> : null}
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>,
    document.getElementById('g-modal'),
  );
};

export default Modal;
